export const PLANNER_CONSTANTS = {
  DND_NEW_EVENT_DURATION_IN_MINUTES: 30,
  DND_TEMP_EVENT_ID_PREFIX: 'DRAGGED-TEMP-EVENT-ID-',
  CLICK_TEMP_DRAFT_ID: 'CLICK-EVENT-DRAFT-TEMP-ID',
  CLICK_TEMP_OPTIMISTIC_ID_PREFIX: 'CLICK-EVENT-OPTIMISTIC-TEMP-ID-',
  PROPOSED_EVENT_ID_PREFIX: 'PROPOSED-EVENT-ID-',
  ACCEPT_PROPOSED_EVENT_ID_PREFIX: 'ACCEPT-PROPOSED-EVENT-ID-',
  CARD_QUICK_ACTIONS_TEMP_OPTIMISTIC_ID_PREFIX:
    'CARD-QUICK-ACTIONS-EVENT-OPTIMISTIC-TEMP-ID-',
  MOVE_EVENT_OPTIMISTIC_ID_PREFIX: 'MOVE-EVENT-OPTIMISTIC-TEMP-ID-',
  CUSTOM_VIEW_KEY_PREFIX: 'planner:custom_view',
  WEEKEND_VIEW_KEY_PREFIX: 'planner:weekend_view',
  GOOGLE_SERVICE_KEY: 'trello-planner-google-calendar',
  OUTLOOK_SERVICE_KEY: 'trello-planner-outlook-calendar',
  IN_PLACE_MESSAGE_EVENT_ID: 'IN-PLACE-MESSAGE-EVENT-ID',
} as const;
